import { initializeApp } from 'firebase/app';
import { getDatabase, ref, push } from 'firebase/database';

// Config duplicated to ensure standalone execution early in bootstrap
const firebaseConfig = {
    apiKey: "AIzaSyCvBjlvW-t1aJauE0iTo8a9bgGqGMVk0Ek",
    authDomain: "babymonitor-live.firebaseapp.com",
    projectId: "babymonitor-live",
    storageBucket: "babymonitor-live.firebasestorage.app",
    messagingSenderId: "266130048548",
    appId: "1:266130048548:web:82656f3efb56a3deae3ab1",
    measurementId: "G-QCTTZQ79GS"
};

export function initRemoteLogging(prefix: string) {
    if ((window as any).__REMOTE_LOGGING_INIT) return;
    (window as any).__REMOTE_LOGGING_INIT = true;

    try {
        // Initialize a secondary internal app to avoid conflicts with Angular's main app init
        const app = initializeApp(firebaseConfig, 'RemoteLogger');
        const db = getDatabase(app);
        const logsRef = ref(db, 'logs');

        const originalLog = console.log;
        const originalError = console.error;
        const originalWarn = console.warn;
        let windowStart = Date.now();
        let windowCount = 0;
        let lastMsg = '';
        let lastMsgAt = 0;
        const MAX_LOGS_PER_MINUTE = 120;
        const DEDUPE_MS = 1000;

        const pushLog = (type: string, args: any[]) => {
            try {
                const now = Date.now();
                if (now - windowStart > 60_000) {
                    windowStart = now;
                    windowCount = 0;
                }
                if (windowCount >= MAX_LOGS_PER_MINUTE) return;

                // Convert args to a single string
                const msg = args.map(arg => {
                    if (arg instanceof Error) {
                        return arg.stack || arg.message;
                    }
                    if (typeof arg === 'object') {
                        try {
                            return JSON.stringify(arg);
                        } catch (err) {
                            return String(arg);
                        }
                    }
                    return String(arg);
                }).join(' ');

                const dedupeKey = `${type}:${msg}`;
                if (dedupeKey === lastMsg && now - lastMsgAt < DEDUPE_MS) return;
                lastMsg = dedupeKey;
                lastMsgAt = now;
                windowCount++;

                const fullMsg = `${prefix} ${new Date().toISOString()} ${type} ${msg}`;

                // Fire and forget
                push(logsRef, fullMsg).catch(() => { });
            } catch (err) {
                // Fail silently
            }
        };

        console.log = (...args: any[]) => {
            originalLog.apply(console, args);
            pushLog('LOG', args);
        };

        console.warn = (...args: any[]) => {
            originalWarn.apply(console, args);
            pushLog('WARN', args);
        };

        console.error = (...args: any[]) => {
            originalError.apply(console, args);
            pushLog('ERROR', args);
        };

        console.log(`${prefix} Remote Logger Initialized`);

    } catch (err) {
        console.error('Failed to initialize remote logger', err);
    }
}
